'use strict';
import {module} from '../app';

module.directive('draggable', ['$rootScope', 'uuid', function ($rootScope, uuid) {
    return {
      restrict: 'A',
      link: function (scope, el, attrs, controller) {
        if (attrs.draggable == 'false') {
          return;
        }

        angular.element(el).attr("draggable", "true");
        let start = 0;

        function is_touch_device() {
          try {
            document.createEvent("TouchEvent");
            return true;
          } catch (e) {
            return false;
          }
        }

        let id = angular.element(el).attr("id");
        if (!id) {
          id = uuid.new();
          angular.element(el).attr("id", id);
        }

        if (is_touch_device()) {
          /*jshint -W055 */
          new webkit_draggable(el[0], {
            revert: true,
            onStart: function () {
              angular.element(el).addClass("lvl-dragging");
              $rootScope.$emit("LVL-DRAG-START");
            },
            onEnd: function () {
              angular.element(el).removeClass("lvl-dragging");
              $rootScope.$emit("LVL-DRAG-END");
            }
          });
        } else {
          el.bind("dragstart", function (e) {

            /**
             *  TODO - Justin - 2016-12-06: Seems not supported anymore ?
             *  https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer#Browser_compatibility
             * */

            if (e.dataTransfer) {
              e.dataTransfer.setData('text', id);
            } else if (e.originalEvent.dataTransfer) {
              e.originalEvent.dataTransfer.setData('text', id);
            } else {
              $(e.target).data('text', id);
            }
            angular.element(el).addClass("lvl-dragging");
            $rootScope.$emit("LVL-DRAG-START");
          });

          el.bind("dragend", function (e) {
            angular.element(el).removeClass("lvl-dragging");
            $rootScope.$emit("LVL-DRAG-END");
          });
        }


      }
    };
  }]);



// WEBPACK FOOTER //
// ./src/scripts/directives/draggable.js